/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash';

const removeEmpty = (value: any): any => {
  if (_.isArray(value)) {
    const arr = value.map(removeEmpty).filter(v => !isEmptyValue(v));
    return arr.length > 0 ? arr : undefined;
  }

  if (_.isPlainObject(value)) {
    const obj = _.mapValues(value, removeEmpty);
    const cleaned = _.pickBy(obj, v => !isEmptyValue(v));
    return Object.keys(cleaned).length > 0 ? cleaned : undefined;
  }

  return value;
};

const isEmptyValue = (v: any) => {
  return (
    v === undefined ||
    v === null ||
    v === '' ||
    (Array.isArray(v) && v.length === 0)
  );
};

const deepSort = (value: any): any => {
  if (_.isArray(value)) {
    return value.map(deepSort);
  }
  if (_.isPlainObject(value)) {
    return _(value)
      .toPairs()
      .sortBy(0)
      .map(([k, v]) => [k, deepSort(v)])
      .fromPairs()
      .value();
  }
  return value;
};

export const stableKey = (obj: any): string => {
  const cleaned = removeEmpty(obj);
  const sorted = deepSort(cleaned);
  return JSON.stringify(sorted);
};
